<template>
   <div>
    
    <div class="nav_footer_bottom">
      <!-- <div class="nav_footer_bottom_link">
        <a href="#">友情链接</a>
        <a href="#">友情链接</a>
        <a href="#">友情链接</a>
        <a href="#">友情链接</a>
        <a href="#">友情链接</a>
        <a href="#">友情链接</a>
        <a href="#">友情链接</a>
        <a href="#">友情链接</a>
        <a href="#">友情链接</a>
      </div> -->
      <div class="nav_footer_bottom_icp">
        <p><a target="_blank" href="https://beian.miit.gov.cn/">粤ICP备2021067583号</a></p>
        <p>中国 © 扬师傅 2026 版权所有</p>
      </div>
    </div>
   </div>
</template>

<script>
export default {
   data (){
       return {
           
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       
   },
   created() {
       
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.nav_footer{
    &_bottom{
        width:100%;
        height:120px;
        margin-bottom:-20px;
        padding:31px calc(50% - 580px) 0 calc(50% - 580px);
        background:#06223C;
        text-align: center;
        color:#9CB4DA;
        font-size: 14px;
        &_link{
        border-top:1px solid #9CB4DA;
        border-bottom:1px solid #9CB4DA;
        padding: 18px 100px;
        display: flex;
        justify-content:space-around;
        a{
            font-size: 14px;
            color:#9CB4DA;
        }
        }
        &_icp{
        padding-top: 20px;
        p{
            line-height: 24px;
            color:#9CB4DA;
            a{
              color:#9CB4DA;
            }
        }
        }
    }
}
  
</style>



// WEBPACK FOOTER //
// src/components/navFooter.vue